/* eslint-disable class-methods-use-this */

import store from 'store/Store';
import userActions from 'actions/UserActions';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Events from 'utils/framework/Events';
import getLocationWithCache from 'services/api/utility/getLocationWithCache';
import getStoreLocations from 'services/api/utility/storeLocator/getStoreLocations';
import localeUtils from 'utils/LanguageLocale';
import storeUtils from 'utils/Store';
import userLocationUtils from 'utils/UserLocation';
import locationUtils from 'utils/Location';
import profileApi from 'services/api/profile';
import cookieUtils from 'utils/Cookies';
import defaultStoreZipCode from 'constants/defaultStoreZipCode';
const { DEFAULT_STORE_ID } = defaultStoreZipCode;

const defaultStore = {
    displayName: null,
    isDefault: true
};

const updatePreferredStoreAndLocalStorage = function (preferredStore, profile) {
    storeUtils.cacheStoreData(preferredStore);
    store.dispatch(userActions.updatePreferredStore({ preferredStoreInfo: preferredStore }));

    if (Sephora.configurationSettings.setZipStoreCookie) {
        cookieUtils.write(cookieUtils.KEYS.PREFERRED_STORE, preferredStore.storeId || DEFAULT_STORE_ID[profile?.profileLocale], null, false, false);
    }
};

const updatePreferredZipcode = function () {
    const reduxState = store.getState();
    const user = reduxState.user;
    const userDataPreferredZipCode = user.preferredZipCode;
    const localStoragePreferredZipCode = Storage.session.getItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE);

    if (localStoragePreferredZipCode) {
        store.dispatch(
            userActions.update(
                {
                    encryptedStoreIds: null,
                    ...localStoragePreferredZipCode
                },
                false
            )
        );

        return;
    }

    // Make sure to update local storage zipcode if the user already has a preferred zipcode
    if (userDataPreferredZipCode) {
        Storage.session.setItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE, { preferredZipCode: userDataPreferredZipCode });

        return;
    }

    if (!localStoragePreferredZipCode && !userDataPreferredZipCode) {
        userLocationUtils
            .setPreferredZipCodeOnSession()
            .then(zipCodeData => {
                // We might have a successfull
                if (zipCodeData.sameDayAvailable) {
                    const zipData = {
                        preferredZipCode: zipCodeData.zipCode,
                        encryptedStoreIds: zipCodeData.encryptedStoreIds
                    };
                    store.dispatch(userActions.update(zipData, false));
                    Storage.session.setItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE, zipData);
                } else {
                    // When the geolocated zip code turns out to not be SDD enabled,
                    // We need to add the empty properties into user store to notify
                    // to the storeIdAndZipCodeSelector that at least we tried to get
                    // this data.
                    store.dispatch(
                        userActions.update(
                            {
                                preferredZipCode: null,
                                encryptedStoreIds: null
                            },
                            false
                        )
                    );
                }
            })
            .catch(() => {
                // SameDay not available for user's location
                store.dispatch(
                    userActions.update(
                        {
                            preferredZipCode: null,
                            encryptedStoreIds: null
                        },
                        false
                    )
                );
            });
    }
};

if (!Sephora.isNodeRender && typeof window !== 'undefined' && !(locationUtils.isVendorLoginPage() || locationUtils.isVendorGenericLogin())) {
    Events.onLastLoadEvent(window, [Events.UserInfoReady], () => {
        store.setAndWatch(['auth.profileStatus'], null, () => {
            const reduxState = store.getState();
            const user = reduxState.user;
            const selectedStore = Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE);

            if (user.preferredStore) {
                if (selectedStore && selectedStore.storeId === user.preferredStore) {
                    store.dispatch(userActions.updatePreferredStore({ preferredStoreInfo: selectedStore }));
                } else {
                    getStoreLocations(user.preferredStore).then(data => {
                        updatePreferredStoreAndLocalStorage(data.stores[0], user.profile);
                        store.dispatch(userActions.storeChangedFromHeader());
                    });
                }
            } else if (selectedStore && user.profileLocale === selectedStore?.address?.country) {
                store.dispatch(userActions.updatePreferredStore({ preferredStoreInfo: selectedStore }));
            } else {
                // Prevent any more location API calls if default store has been set (user is browsing from other country
                if (!selectedStore?.isDefault) {
                    getLocationWithCache({ radius: localeUtils.getCountrySearchRadius() })
                        .then(data => {
                            const nearestStore = data.stores[0];
                            //Update the preferred store only when the locale matches else use default

                            if (user.profileLocale === nearestStore?.address?.country) {
                                profileApi
                                    .switchPreferredStore(nearestStore.storeId, false)
                                    .finally(() => {
                                        updatePreferredStoreAndLocalStorage(nearestStore, user.profile);
                                    })
                                    .catch(() => { });
                            } else {
                                updatePreferredStoreAndLocalStorage(defaultStore, user.profile);
                            }
                        })
                        .catch(() => {
                            updatePreferredStoreAndLocalStorage(defaultStore, user.profile);
                        });
                } else {
                    store.dispatch(userActions.updatePreferredStore({ preferredStoreInfo: selectedStore }));
                }
            }
        });

        updatePreferredZipcode();
    });
}

export default {};
